import { render, staticRenderFns } from "./headerUserMenu.vue?vue&type=template&id=5e88436e&scoped=true"
import script from "./headerUserMenu.vue?vue&type=script&lang=js"
export * from "./headerUserMenu.vue?vue&type=script&lang=js"
import style0 from "./headerUserMenu.vue?vue&type=style&index=0&id=5e88436e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88436e",
  null
  
)

export default component.exports